// extracted by mini-css-extract-plugin
export default {"returnsAndExchanges":"Qo-z","returnHeader":"Ro-z","titleAndReturnPolicyLink":"So-z","ourReturnPolicy":"To-z","boxes":"Uo-z","illustration":"Vo-z","address":"Wo-z"};